import React from 'react';
import { LayoutManagerDictionary } from 'layoutManagement/LayoutManagerDictionary';
import LayoutNamePromptContent from 'layoutManagement/LayoutNamePromptContent';

export interface SaveCurrentLayoutAsContentProps {
    saveCurrentLayoutAsName: string;
    onSaveCurrentLayoutAsNameChanged: (name: string) => void;
    onEnter: () => void;
    error: string;
    isInvalid: boolean;
    dictionary: LayoutManagerDictionary;
}

export default function SaveCurrentLayoutAsContent(
    props: SaveCurrentLayoutAsContentProps
) {
    const {
        saveCurrentLayoutAsName,
        onSaveCurrentLayoutAsNameChanged,
        onEnter,
        dictionary,
        isInvalid,
        error,
    } = props;

    return (
        <LayoutNamePromptContent
            className="SaveCurrentLayoutAsContent"
            title={dictionary.saveCurrentTitle}
            layoutName={saveCurrentLayoutAsName}
            onLayoutNameChanged={onSaveCurrentLayoutAsNameChanged}
            isInvalid={isInvalid}
            error={error}
            onEnter={onEnter}
        />
    );
}
